import { partition } from 'es-toolkit';

import { naturalSortByProperty } from '@paragon/utilities';

export function sortMaterialLists<T extends { name: string; isArchived: boolean }>(lists: readonly T[]): readonly T[] {
  const [archivedLists, normalLists] = partition(lists, (list) => list.isArchived);

  return naturalSortByProperty(normalLists, (list) => list.name).concat(
    naturalSortByProperty(archivedLists, (list) => list.name),
  );
}
